import type { SharedOutput } from 'app/lib/types/server';

type SharePick = Pick<SharedOutput, 'id' | 'transformationId'>;

export function createScheduledShareIds(share: SharePick): {
    uid: string;
    entityId: string;
} {
    const uid = createScheduledShareUid(share.id);
    const entityId = createScheduledShareEntityId(share.transformationId, uid);
    return { uid, entityId };
}

function createScheduledShareEntityId(transformationId: string, uid: string): string {
    const [projectUid] = transformationId.split('.');
    const entityId = `${projectUid}.${uid}`;
    return entityId;
}

function createScheduledShareUid(shareId: number): string {
    return `_se${shareId}`;
}
